import { render, staticRenderFns } from "./RecoMobiles.vue?vue&type=template&id=6005779a&scoped=true&"
import script from "./RecoMobiles.vue?vue&type=script&lang=js&"
export * from "./RecoMobiles.vue?vue&type=script&lang=js&"
import style0 from "./RecoMobiles.vue?vue&type=style&index=0&id=6005779a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6005779a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37614586/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6005779a')) {
      api.createRecord('6005779a', component.options)
    } else {
      api.reload('6005779a', component.options)
    }
    module.hot.accept("./RecoMobiles.vue?vue&type=template&id=6005779a&scoped=true&", function () {
      api.rerender('6005779a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/selector/fragment/RecoMobiles.vue"
export default component.exports